package com.vizio.redwolf.utils

import kotlin.js.JsExport

@JsExport
interface AvodEnvironment : Environment {
    val catalogHost: String
    val contentDetailsHost: String
    val searchHost: String
    val path: String
}

@JsExport
abstract class BaseAvodEnvironment(override val path: String = "/v4") : AvodEnvironment

@JsExport
data class DevAvodEnvironment(
    override val catalogHost: String = "catalog-dev.smartcasttv.com",
    override val contentDetailsHost: String = "content-details-dev.smartcasttv.com",
    override val searchHost: String = "voice-search-dev.smartcasttv.com"
) : BaseAvodEnvironment()

@JsExport
data class StageAvodEnvironment(
    override val catalogHost: String = "catalog-stage.smartcasttv.com",
    override val contentDetailsHost: String = "content-details-stage.smartcasttv.com",
    override val searchHost: String = "voice-search-stage.smartcasttv.com"
) : BaseAvodEnvironment()

@JsExport
data class ProdAvodEnvironment(
    override val catalogHost: String = "catalog-prod.smartcasttv.com",
    override val contentDetailsHost: String = "content-details-prod.smartcasttv.com",
    override val searchHost: String = "voice-search-prod.smartcasttv.com"
) : BaseAvodEnvironment()

@JsExport
data class TestAvodEnvironment(
    override val catalogHost: String = "catalog-test.smartcasttv.com",
    override val contentDetailsHost: String = "content-details-test.smartcasttv.com",
    override val searchHost: String = TODO("TestAvodEnvironment for searchHost not defined yet!")
) : BaseAvodEnvironment()

fun chooseAvodEnvironment(envConfig: AvodEnvironmentConfig): AvodEnvironment {
    return when (envConfig.environmentGroup) {
        EnvironmentGroup.PROD -> ProdAvodEnvironment()
        EnvironmentGroup.PREPROD -> TODO("PREPROD Environment for AvodEnvironment not defined yet!")
        EnvironmentGroup.STAGE -> StageAvodEnvironment()
        EnvironmentGroup.DEV -> DevAvodEnvironment()
        EnvironmentGroup.TEST -> TestAvodEnvironment()
    }
}


